import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Facilities from "@/components/site/Facilities";
import Pricing from "@/components/site/Pricing";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";

const Home = () => {
  return (
    <div className="bg-[#fcf3e6] min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <About />
        <Facilities />
        <Pricing />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#012a2d",
            color: "#fcf3e6",
            border: "1px solid #048a93",
            borderRadius: "16px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
